import {TreeContext} from "../../../utils/contexts";

const { ListItem, ListItemText, ListItemIcon, CircularProgress, withStyles } = window.Material;
const { Folder, FolderOpen, KeyboardArrowRight, KeyboardArrowDown } = window.MaterialIcons;

import TreeRowChild from './TreeRow';

const styles = () => ({
  root: {
    fontSize: '13px',
    wordBreak: 'break-all',
  },
  listItem: {
    paddingLeft: 0,
    paddingTop: '5px',
    paddingBottom: '5px',
    width: 'calc(300px + 0.5rem)',
  },
  icon: {
    minWidth: '0',
    marginRight: '5px',
    alignItems: 'center',
  },
  noChildrenIcon: {
    marginLeft: '0.1rem',
  },
});

class TreeRow extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      open: props.level === 0 || Boolean(this.props.treeItems[this.props.item.nodeRef]),
    };
  }

  componentDidUpdate(oldProps) {
    if (!Boolean(oldProps.treeItems[oldProps.item.nodeRef]) && Boolean(this.props.treeItems[this.props.item.nodeRef])) {
      this.setState({
        open: true,
      });
    }
  }

  onClick = async event => {
    event.preventDefault();

    const {
      item: { nodeRef },
      treeItems,
    } = this.props;

    const { fetchContent, fetchTreeChildren, breadcrumbs, fetchBreadcrumbs } = this.context;

    const isCurrent = nodeRef === breadcrumbs[breadcrumbs.length - 1]?.nodeRef;

    if (isCurrent) {
      this.setState(state => ({ open: !state.open }));
    } else {
      await fetchContent(nodeRef, 1);
      fetchBreadcrumbs(nodeRef);

      if (!Boolean(treeItems[nodeRef])) {
        await fetchTreeChildren(nodeRef);
      }

      this.setState(() => ({ open: true }));
    }
  };

  handleHideFolder = event => {
    event && event.stopPropagation();

    this.setState(() => ({ open: false }));
  };

  handleShowFolder = async event => {
    event && event.stopPropagation();

    const {
      item: { nodeRef },
      treeItems,
    } = this.props;

    const { fetchTreeChildren } = this.context;

    if (!Boolean(treeItems[nodeRef])) {
      await fetchTreeChildren(nodeRef);
    }

    this.setState(() => ({ open: true }));
  };

  render() {
    const {
      item: { nodeRef, hasChildren, name },
      level,
      isHidden,
      classes,
      treeItems,
    } = this.props;

    const { open } = this.state;

    const { breadcrumbs, loadingItem } = this.context;

    const children = treeItems[nodeRef] || [];
    const display = isHidden ? 'none' : 'block';

    const isCurrent = breadcrumbs[breadcrumbs.length - 1]?.nodeRef === nodeRef;

    return (
      <div
        style={{
          marginLeft: level === 0 ? 0 : hasChildren ? '1rem' : '2.18rem',
          display,
        }}
      >
        <ListItem
          onClick={Boolean(loadingItem) ? null : this.onClick}
          classes={{ root: classes.listItem }}
          button
        >
          <ListItemIcon classes={{ root: classes.icon }}>
            {hasChildren && !open && <KeyboardArrowRight onClick={Boolean(loadingItem) ? null : this.handleShowFolder} fontSize="small" />}
            {hasChildren && open && <KeyboardArrowDown onClick={Boolean(loadingItem) ? null : this.handleHideFolder} fontSize="small" />}
            {loadingItem === nodeRef && <CircularProgress size="13px" />}
            {loadingItem !== nodeRef && isCurrent && (
              <Folder color="primary" classes={hasChildren ? null : { root: classes.noChildrenIcon }} fontSize="small" />
            )}
            {loadingItem !== nodeRef && !isCurrent && (
              <FolderOpen classes={hasChildren ? null : { root: classes.noChildrenIcon }} color="primary" fontSize="small" />
            )}
          </ListItemIcon>
          <ListItemText className={classes.root} disableTypography>
            {name}
          </ListItemText>
        </ListItem>
        {children &&
          children.map((it, index) => (
            <TreeRowChild key={index} item={it} level={level + 1} isHidden={!open} treeItems={treeItems} />
          ))}
      </div>
    );
  }
}

TreeRow.contextType = TreeContext;

export default withStyles(styles)(TreeRow);
